// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__ihHFO","canvas":"style_canvas__6M6z7","button":"style_button__j6tiz"};